export default {
  FilterSettings: [
    {
      Name: 'Academy',
      To: '/Academy',
      Icon: 'learning',
    },
    {
      Name: 'Alchemy',
      To: '/Alchemy',
      Icon: 'lab-test',
    },
    {
      Name: 'Battle Arena',
      To: '/BattleArena',
      Icon: 'selection',
    },
    {
      Name: 'Capture the Flag',
      To: '/CaptureTheFlag',
      Icon: 'flag',
    },
    {
      Name: 'Fortress War',
      To: '/FortressWar',
      Icon: 'crown',
    },
    {
      Name: 'Global Chat',
      To: '/GlobalChat',
      Icon: 'cell-tower',
    },
    {
      Name: 'Guild and Union',
      To: '/GuildAndUnion',
      Icon: 'search-around',
    },
    {
      Name: 'Item Editor',
      To: '/ItemEditor',
      Icon: 'draw',
    },
    { Name: 'Jobs', To: '/Jobs', Icon: 'graph' },
    {
      Name: 'Notification',
      To: '/Notification',
      Icon: 'notifications',
    },
    {
      Name: 'NPC Editor',
      To: '/NPCEditor',
      Icon: 'mugshot',
    },
    {
      Name: 'Pet',
      To: '/Pet',
      Icon: 'bank-account',
    },
    {
      Name: 'PK Settings',
      To: '/PKSettings',
      Icon: 'ninja',
    },
    {
      Name: 'Player Icon',
      To: '/PlayerIcon',
      Icon: 'following',
    },
    {
      Name: 'Ranks',
      To: '/Ranks',
      Icon: 'numbered-list',
    },
    {
      Name: 'Rate Editor',
      To: '/RateEditor',
      Icon: 'prescription',
    },
    {
      Name: 'Regions',
      To: '/Regions',
      Icon: 'path-search',
    },
    {
      Name: 'Reverse Scroll',
      To: '/ReverseScroll',
      Icon: 'undo',
    },
    {
      Name: 'Scheduled Gifts',
      To: '/ScheduledGifts',
      Icon: 'stopwatch',
    },
    {
      Name: 'Whell of Fortune',
      To: '/WhellOfFortune',
      Icon: 'flash',
    },
    {
      Name: 'AFK System',
      To: '/AFKSystem',
      Icon: 'issue-closed',
    },
    {
      Name: 'Auto Events',
      To: '/AutoEvents',
      Icon: 'automatic-updates',
    },
    {
      Name: 'Features',
      To: '/Features',
      Icon: 'settings',
    },
    {
      Name: 'GM Console',
      To: '/GMConsole',
      Icon: 'console',
    },
    {
      Name: 'Level',
      To: '/Level',
      Icon: 'timeline-line-chart',
    },
    {
      Name: 'Mastery Level',
      To: '/MasteryLevel',
      Icon: 'series-configuration',
    },
    {
      Name: 'PC/IP Limit',
      To: '/PCIPLimit',
      Icon: 'ip-address',
    },
  ],
  WebSettings: [
    {
      Name: 'Web Settings',
      To: '/WebSettings',
      Icon: 'globe-network',
    },
    {
      Name: 'Web News',
      To: '/WebNews',
      Icon: 'manually-entered-data',
    },
    {
      Name: 'Web Store',
      To: '/WebStore',
      Icon: 'shop',
    },
    {
      Name: 'Admin Roles',
      To: '/AdminRoles',
      Icon: 'eye-on',
    },
    {
      Name: 'Web Downloads',
      To: '/WebDownloads',
      Icon: 'download',
    },
    { Name: 'Web FAQ', To: '/WebFAQ', Icon: 'help' },
  ],
  ServerSettings: [
    { Name: 'Server Settings', To: '/ServerSettings', Icon: 'cog' },
    {
      Name: 'Gateways',
      To: '/Gateways',
      Icon: 'pivot',
    },
    { Name: 'Agents', To: '/Agents', Icon: 'path' },
    {
      Name: 'Database',
      To: '/Database',
      Icon: 'database',
    },
    {
      Name: 'DLL Settings',
      To: '/DLLSettings',
      Icon: 'code',
    },
    {
      Name: 'Procedures',
      To: '/Procedures',
      Icon: 'derive-column',
    },
  ],
};
